import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var GoogleLogoDisabled = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "M27.767 13.65H26.8v-.05H16v4.8h6.782A7.197 7.197 0 0 1 8.8 16 7.2 7.2 0 0 1 16 8.8c1.835 0 3.505.692 4.777 1.823l3.394-3.394A11.946 11.946 0 0 0 16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12c0-.805-.083-1.59-.233-2.35z" }))); }));
GoogleLogoDisabled.displayName = 'GoogleLogoDisabled';
GoogleLogoDisabled['iconName'] = 'google-logo-disabled';
export default GoogleLogoDisabled;
